import laborupLightText from "@/assets/laborup_dark_text_light.svg";
import laborupDarkText from "@/assets/laborup_dark_text.svg";
import { LaborupGear, Row } from "@/components";
import { cn } from "@/lib/utils";

export const SidebarLogo = ({ isWinter = false }: { isWinter?: boolean }) => {
  /* Render */
  const render = () => (
    <Row
      className={cn(
        "items-center gap-2",
        isWinter ? "text-[#C6D6E2]" : "text-[#006ADC] dark:text-[#C6D6E2]",
      )}
    >
      <LaborupGear color="currentColor" height={24} width={24} />
      <img
        alt="Laborup"
        className={cn("h-[18px] w-[76px]", !isWinter && "dark:hidden")}
        src={isWinter ? laborupLightText : laborupDarkText}
      />
      {!isWinter ? (
        <img
          alt="Laborup"
          className="hidden h-[18px] w-[76px] dark:block"
          src={laborupLightText}
        />
      ) : null}
    </Row>
  );

  return render();
};
